// extracted by mini-css-extract-plugin
export default {"container":"RoundRobinStandings_container__4Q+e0","title":"RoundRobinStandings_title__LSv9e","table":"RoundRobinStandings_table__ozD7s"};